import { unsubscribe } from './unsubscribe';
function storeEventListener(type, callback) {
    var StStCustomEventsStore = window.StStCustomEventsStore;
    if (!StStCustomEventsStore.hasOwnProperty(type)) {
        StStCustomEventsStore[type] = [];
    }
    StStCustomEventsStore[type].push(callback);
}
export function subscribe(type, callback) {
    document.addEventListener(type, callback);
    storeEventListener(type, callback);
    return function () {
        unsubscribe(type, callback);
    };
}
//# sourceMappingURL=subscribe.js.map